import interceptor from '@/plugins/interceptor';
const pathUsers = '/ForgeUsers'
const pathDash = '/ForgeDash'

export default {
    state: () => ({
    
    }),
    mutations: { 
    },
    actions: {
        /* Viejo
        async forgeDash_tutorResume(_,id) { 
            const ret = await interceptor.external.get(`${process.env.VUE_APP_API_BACKOFFICE_URL}${pathDash}/tutor/${id}/resume`, interceptor.rukyExternalToken);
            return ret.data;
        }, 
        */
        async forgeDash_tutorResume(_,params) { 
            const ret = await interceptor.external.get(`${process.env.VUE_APP_API_BACKOFFICE_URL}${pathDash}/tutor/${params.id}/resumeNew?${params.queryParams}`, interceptor.rukyExternalToken);
            return ret.data;
        }, 
        async forgeDash_userapplied(_,id) {
            const ret = await interceptor.external.get(`${process.env.VUE_APP_API_BACKOFFICE_URL}${pathDash}/tutor/${id}/userapplied`, interceptor.rukyExternalToken);
            return ret.data;
        },
        async forgeDash_userNotApplied(_,id) {
            const ret = await interceptor.external.get(`${process.env.VUE_APP_API_BACKOFFICE_URL}${pathDash}/tutor/${id}/usernotapplied`, interceptor.rukyExternalToken);
            return ret.data;
        },
        async forgeDash_profileCompleted(_,id) {
            const ret = await interceptor.external.get(`${process.env.VUE_APP_API_BACKOFFICE_URL}${pathDash}/tutor/${id}/profileCompleted`, interceptor.rukyExternalToken);
            return ret.data;
        },
        async forgeDash_profileNotCompleted(_,id) {
            const ret = await interceptor.external.get(`${process.env.VUE_APP_API_BACKOFFICE_URL}${pathDash}/tutor/${id}/profileNotCompleted`, interceptor.rukyExternalToken);
            return ret.data;
        },
        async forgeDash_jobSearches(__,params) {
            const ret = await interceptor.external.get(`${process.env.VUE_APP_API_BACKOFFICE_URL}${pathDash}/tutor/${params.id}/jobSearches/published?${params.queryParams}`, interceptor.rukyExternalToken);
            return ret.data;
        },
        async forgeDash_jobSearch(_,id) {
            const ret = await interceptor.external.get(`${process.env.VUE_APP_API_BACKOFFICE_URL}${pathDash}/jobSearches/${id}`, interceptor.rukyExternalToken);
            return ret.data;
        },
        /* VIEJO
        async forgeDash_cordinatorResume(_,id) {
            const ret = await interceptor.external.get(`${process.env.VUE_APP_API_BACKOFFICE_URL}${pathDash}/cordinator/${id}/resume`, interceptor.rukyExternalToken);
            return ret.data;
        },
        */
        async forgeDash_cordinatorResume(_,params) {
            const ret = await interceptor.external.get(`${process.env.VUE_APP_API_BACKOFFICE_URL}${pathDash}/cordinator/${params.id}/resumeNew?${params.queryParams}`, interceptor.rukyExternalToken);
            return ret.data;
        },
        async forgeDash_alliance(_,params) {
            const ret = await interceptor.external.get(`${process.env.VUE_APP_API_BACKOFFICE_URL}${pathDash}/forgeAlliance/${params.id}?${params.queryParams}`, interceptor.rukyExternalToken);
            return ret.data;
        },
        async forgeUsers_profileResume(_,id) {
            const ret = await interceptor.external.get(`${process.env.VUE_APP_API_BACKOFFICE_URL}${pathUsers}/profiles/${id}/resume`, interceptor.rukyExternalToken);
            return ret.data;
        },
        async forgeUsers_profileDetail(_,id) {
            const ret = await interceptor.authenticate.get(`${process.env.VUE_APP_API_BACKOFFICE_URL}${pathUsers}/profiles/${id}`);
            return ret.data;
        },
        async forgeDash_jobSearch_getExcelReport(_,params){
            return await interceptor.external.getFile(`${process.env.VUE_APP_API_BACKOFFICE_URL}${pathDash}/jobSearches/${params.searchId}/appliesForTutor/${params.tutorId}`, params.fileName, interceptor.rukyExternalToken);
        },
        async forgeDash_getFiliales(_,id){
            return await interceptor.external.get(`${process.env.VUE_APP_API_BACKOFFICE_URL}${pathDash}/forgeFiliales/${id}`, interceptor.rukyExternalToken);
        }
    }
}
